"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var ReactDOM = _interopRequireWildcard(require("react-dom"));
var _KeyCode = _interopRequireDefault(require("rc-util/lib/KeyCode"));
var _contains = _interopRequireDefault(require("rc-util/lib/Dom/contains"));
var _rcAnimate = _interopRequireDefault(require("rc-animate"));
var _LazyRenderBox = _interopRequireDefault(require("./LazyRenderBox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var uuid = 0;
var HORIZONTAL_OVERFLOW = 200;

/* eslint react/no-is-mounted:0 */

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }
  return ret;
}
function setTransformOrigin(node, value) {
  var style = node.style;
  ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
    style["".concat(prefix, "TransformOrigin")] = value;
  });
  style["transformOrigin"] = value;
}
function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
var Dialog = exports.default = /*#__PURE__*/function (_React$Component) {
  function Dialog(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, Dialog);
    _this = _callSuper(this, Dialog, [_props]);
    (0, _defineProperty2.default)(_this, "inTransition", false);
    (0, _defineProperty2.default)(_this, "titleId", void 0);
    (0, _defineProperty2.default)(_this, "openTime", void 0);
    (0, _defineProperty2.default)(_this, "lastOutSideFocusNode", void 0);
    (0, _defineProperty2.default)(_this, "wrap", void 0);
    (0, _defineProperty2.default)(_this, "dialog", void 0);
    (0, _defineProperty2.default)(_this, "sentinelStart", void 0);
    (0, _defineProperty2.default)(_this, "sentinelEnd", void 0);
    (0, _defineProperty2.default)(_this, "dialogMouseDown", void 0);
    (0, _defineProperty2.default)(_this, "timeoutId", void 0);
    (0, _defineProperty2.default)(_this, "switchScrollingEffect", void 0);
    (0, _defineProperty2.default)(_this, "onAnimateLeave", function () {
      var afterClose = _this.props.afterClose;
      // need demo?
      // https://github.com/react-component/dialog/pull/28
      if (_this.wrap) {
        _this.wrap.style.display = 'none';
      }
      _this.inTransition = false;
      _this.switchScrollingEffect();
      if (afterClose) {
        afterClose();
      }
    });
    (0, _defineProperty2.default)(_this, "onDialogMouseDown", function () {
      _this.dialogMouseDown = true;
    });
    (0, _defineProperty2.default)(_this, "onMaskMouseUp", function () {
      if (_this.dialogMouseDown) {
        _this.timeoutId = setTimeout(function () {
          _this.dialogMouseDown = false;
        }, 0);
      }
    });
    (0, _defineProperty2.default)(_this, "onMaskClick", function (e) {
      // android trigger click on open (fastclick??)
      if (Date.now() - _this.openTime < 300) {
        return;
      }
      if (e.target === e.currentTarget && !_this.dialogMouseDown) {
        _this.close(e);
      }
    });
    (0, _defineProperty2.default)(_this, "onKeyDown", function (e) {
      var props = _this.props;
      if (props.keyboard && e.keyCode === _KeyCode.default.ESC) {
        e.stopPropagation();
        _this.close(e);
        return;
      }
      // keep focus inside dialog
      if (props.visible) {
        if (e.keyCode === _KeyCode.default.TAB) {
          var activeElement = document.activeElement;
          var sentinelStart = _this.sentinelStart;
          if (e.shiftKey) {
            if (activeElement === sentinelStart) {
              _this.sentinelEnd.focus();
            }
          } else if (activeElement === _this.sentinelEnd) {
            sentinelStart.focus();
          }
        }
      }
    });
    (0, _defineProperty2.default)(_this, "getDialogElement", function () {
      var props = _this.props;
      var closable = props.closable;
      var prefixCls = props.prefixCls;
      var dest = {};
      if (props.width !== undefined) {
        dest.width = props.width;
      }
      if (props.height !== undefined) {
        dest.height = props.height;
      }
      var footer;
      if (props.footer) {
        footer = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-footer"),
          ref: _this.saveRef('footer')
        }, props.footer);
      }
      var header;
      if (props.title) {
        header = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-header"),
          ref: _this.saveRef('header')
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-title"),
          id: _this.titleId
        }, props.title));
      }
      var closer;
      if (closable) {
        closer = /*#__PURE__*/React.createElement("button", {
          type: "button",
          onClick: function onClick() {
            return _this.close({
              type: 'close-icon'
            });
          },
          "aria-label": "Close",
          className: "".concat(prefixCls, "-close")
        }, props.closeIcon || /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        }));
      }
      var style = _objectSpread(_objectSpread({}, props.style), dest);
      var sentinelStyle = {
        width: 0,
        height: 0,
        overflow: 'hidden',
        outline: 'none'
      };
      var transitionName = _this.getTransitionName();
      var dialogElement = /*#__PURE__*/React.createElement(_LazyRenderBox.default, {
        key: "dialog-element",
        role: "document",
        ref: _this.saveRef('dialog'),
        style: style,
        className: "".concat(prefixCls, " ").concat(props.className || ''),
        visible: props.visible,
        forceRender: props.forceRender,
        onMouseDown: _this.onDialogMouseDown
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        ref: _this.saveRef('sentinelStart'),
        style: sentinelStyle,
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-content"),
        ref: _this.saveRef('content')
      }, closer, !props.centered && header, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
        className: "".concat(prefixCls, "-body"),
        style: props.bodyStyle,
        ref: _this.saveRef('body')
      }, props.bodyProps), props.children), footer), /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        ref: _this.saveRef('sentinelEnd'),
        style: sentinelStyle,
        "aria-hidden": "true"
      }));
      return /*#__PURE__*/React.createElement(_rcAnimate.default, {
        key: "dialog",
        showProp: "visible",
        onLeave: _this.onAnimateLeave,
        transitionName: transitionName,
        component: "",
        transitionAppear: true
      }, props.visible || !props.destroyOnClose ? dialogElement : null);
    });
    (0, _defineProperty2.default)(_this, "getZIndexStyle", function () {
      var style = {};
      var props = _this.props;
      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }
      return style;
    });
    (0, _defineProperty2.default)(_this, "getWrapStyle", function () {
      return _objectSpread(_objectSpread({}, _this.getZIndexStyle()), _this.props.wrapStyle);
    });
    (0, _defineProperty2.default)(_this, "getMaskStyle", function () {
      return _objectSpread(_objectSpread({}, _this.getZIndexStyle()), _this.props.maskStyle);
    });
    (0, _defineProperty2.default)(_this, "getMaskElement", function () {
      var props = _this.props;
      var maskElement;
      if (props.mask) {
        var maskTransition = _this.getMaskTransitionName();
        maskElement = /*#__PURE__*/React.createElement(_LazyRenderBox.default, (0, _extends2.default)({
          style: _this.getMaskStyle(),
          key: "mask",
          className: "".concat(props.prefixCls, "-mask"),
          hiddenClassName: "".concat(props.prefixCls, "-mask-hidden"),
          visible: props.visible
        }, props.maskProps));
        if (maskTransition) {
          maskElement = /*#__PURE__*/React.createElement(_rcAnimate.default, {
            key: "mask",
            showProp: "visible",
            transitionAppear: true,
            component: "",
            transitionName: maskTransition
          }, maskElement);
        }
      }
      return maskElement;
    });
    (0, _defineProperty2.default)(_this, "getMaskTransitionName", function () {
      var props = _this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;
      if (!transitionName && animation) {
        transitionName = "".concat(props.prefixCls, "-").concat(animation);
      }
      return transitionName;
    });
    (0, _defineProperty2.default)(_this, "getTransitionName", function () {
      var props = _this.props;
      var transitionName = props.transitionName;
      var animation = props.animation;
      if (!transitionName && animation) {
        transitionName = "".concat(props.prefixCls, "-").concat(animation);
      }
      return transitionName;
    });
    (0, _defineProperty2.default)(_this, "close", function (e) {
      var onClose = _this.props.onClose;
      if (onClose) {
        onClose(e);
      }
    });
    (0, _defineProperty2.default)(_this, "saveRef", function (name) {
      return function (node) {
        _this[name] = node;
      };
    });
    _this.titleId = "rcDialogTitle".concat(uuid++);
    _this.switchScrollingEffect = _props.switchScrollingEffect || function () {};
    _this.draggable = _this.props.title.props.children !== undefined && !_this.props.centered;
    _this.onDrag = _this.onDrag.bind(_this);
    _this.getPosition = _this.getPosition.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(Dialog, _React$Component);
  return (0, _createClass2.default)(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.componentDidUpdate({});
      // if forceRender is true, set element style display to be none;
      if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
        this.wrap.style.display = 'none';
      }
      var header = this.header;
      var wrap = this.wrap;
      if (this.draggable) {
        var _document$body2;
        header === null || header === void 0 ? void 0 : header.addEventListener('mousedown', function () {
          var _document$body;
          wrap === null || wrap === void 0 ? void 0 : wrap.classList.add('modal-drag-start');
          (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.addEventListener('mousemove', _this2.onDrag);
        });
        (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.addEventListener('mouseup', function () {
          var _document$body3;
          wrap === null || wrap === void 0 ? void 0 : wrap.classList.remove('modal-drag-start');
          (_document$body3 = document.body) === null || _document$body3 === void 0 ? void 0 : _document$body3.removeEventListener('mousemove', _this2.onDrag);
        });
        this.getPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        visible = _this$props.visible,
        mask = _this$props.mask,
        focusTriggerAfterClose = _this$props.focusTriggerAfterClose;
      var mousePosition = this.props.mousePosition;
      if (this.draggable) {
        this.getPosition();
      }
      if (visible) {
        // first show
        if (!prevProps.visible) {
          this.openTime = Date.now();
          this.switchScrollingEffect();
          this.tryFocus();
          var dialogNode = ReactDOM.findDOMNode(this.dialog);
          if (mousePosition) {
            var elOffset = offset(dialogNode);
            setTransformOrigin(dialogNode, "".concat(mousePosition.x - elOffset.left, "px ").concat(mousePosition.y - elOffset.top, "px"));
          } else {
            setTransformOrigin(dialogNode, '');
          }
        }
      } else if (prevProps.visible) {
        this.inTransition = true;
        if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
          try {
            this.lastOutSideFocusNode.focus();
          } catch (e) {
            this.lastOutSideFocusNode = null;
          }
          this.lastOutSideFocusNode = null;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
        visible = _this$props2.visible,
        getOpenCount = _this$props2.getOpenCount;
      if ((visible || this.inTransition) && !getOpenCount()) {
        this.switchScrollingEffect();
      }
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "tryFocus",
    value: function tryFocus() {
      if (!(0, _contains.default)(this.wrap, document.activeElement)) {
        this.lastOutSideFocusNode = document.activeElement;
        this.sentinelStart.focus();
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      var _window$getComputedSt = window.getComputedStyle(this.content),
        width = _window$getComputedSt.width,
        height = _window$getComputedSt.height;
      var _window$getComputedSt2 = window.getComputedStyle(this.content.parentElement),
        parentMarginLeft = _window$getComputedSt2.marginLeft,
        parentMarginTop = _window$getComputedSt2.marginTop,
        parentTop = _window$getComputedSt2.top;

      // get horizontal values
      var intParentMarginLeft = parseInt(parentMarginLeft);
      var contentWidth = this.props.size === 'maximum' ? parseInt(width) + 25 : parseInt(width);
      var windowWidth = parseInt(window.innerWidth);
      var dialogPositionLeftFromStorage = sessionStorage.getItem('dialogPositionLeft');
      var intDialogPositionLeftFromStorage = parseInt(dialogPositionLeftFromStorage);

      // calculate horizontal overflow
      var isOutFromLeft = intParentMarginLeft + intDialogPositionLeftFromStorage <= 0;
      var isOutFromRight = intParentMarginLeft + contentWidth + intDialogPositionLeftFromStorage >= windowWidth;

      // get vertical values
      var intParentMarginTop = parseInt(parentMarginTop);
      var contentHeight = parseInt(height);
      var positionTop = parseInt(parentTop) + parseInt(parentMarginTop);
      var windowHeight = parseInt(window.innerHeight);
      var dialogPositionTopFromStorage = sessionStorage.getItem('dialogPositionTop');
      var intDialogPositionTopFromStorage = parseInt(dialogPositionTopFromStorage);

      // calculate vertical overflow
      var isOutFromTop = positionTop + intDialogPositionTopFromStorage <= 0;
      var isOutFromBottom = positionTop + intDialogPositionTopFromStorage + contentHeight >= windowHeight;
      if (this.props.title.props.children !== undefined && !this.props.centered) {
        // check horizontal overflow
        if (isOutFromLeft) {
          this.content.style.left = -intParentMarginLeft + 'px';
        } else if (isOutFromRight) {
          this.content.style.left = windowWidth - contentWidth - intParentMarginLeft + 'px';
        } else if (isNaN(contentWidth)) {
          this.content.style.left = dialogPositionLeftFromStorage;
        }

        // check vertical overflow
        if (isOutFromTop) {
          this.content.style.top = -intParentMarginTop - parseInt(parentTop) + 'px';
        } else if (isOutFromBottom) {
          this.content.style.top = windowHeight - parseInt(parentTop) - parseInt(parentMarginTop) - contentHeight + 'px';
        } else {
          this.content.style.top = dialogPositionTopFromStorage;
        }
      }
    }
  }, {
    key: "onDrag",
    value: function onDrag(_ref) {
      var movementX = _ref.movementX,
        movementY = _ref.movementY;
      var allowOverflow = this.props.allowOverflow;
      var _window$getComputedSt3 = window.getComputedStyle(this.content),
        left = _window$getComputedSt3.left,
        top = _window$getComputedSt3.top,
        width = _window$getComputedSt3.width,
        height = _window$getComputedSt3.height;
      var _window$getComputedSt4 = window.getComputedStyle(this.content.parentElement),
        parentMarginLeft = _window$getComputedSt4.marginLeft,
        parentMarginTop = _window$getComputedSt4.marginTop,
        parentTop = _window$getComputedSt4.top;
      var dialogBody = this.content.querySelector("div[class$='body']");
      var _window$getComputedSt5 = window.getComputedStyle(dialogBody),
        bodyHeight = _window$getComputedSt5.height;
      bodyHeight = parseInt(bodyHeight);
      var footerHeight = 0;
      var dialogFooter = this.content.querySelector("div[class$='footer']");
      if (dialogFooter) {
        footerHeight = window.getComputedStyle(dialogFooter).height;
        footerHeight = parseInt(footerHeight) || 0;
      }

      // Modal açıldığında arkasında kalan kısımların görüntülenebilmesi için overflow'a izin verilicek.
      var verticalOverflow = allowOverflow ? bodyHeight + footerHeight : 0;
      var horizontalOverflow = allowOverflow ? HORIZONTAL_OVERFLOW : 0;

      // get horizontal values
      var positionLeft = parseInt(parentMarginLeft) + parseInt(left) + parseInt(movementX);
      var contentWidth = this.props.size === 'maximum' ? parseInt(width) + 10 : parseInt(width);
      var windowWidth = parseInt(window.innerWidth);

      // check horizontal overflow
      if (positionLeft >= -horizontalOverflow && positionLeft - horizontalOverflow < windowWidth - contentWidth) {
        this.content.style.left = "".concat(parseInt(left) + movementX, "px");
        sessionStorage.setItem('dialogPositionLeft', this.content.style.left);
      }

      // get vertical values
      var positionTop = parseInt(parentTop) + parseInt(parentMarginTop) + parseInt(top) + parseInt(movementY);
      var contentHeight = this.props.size === 'maximum' ? parseInt(height) + 10 : parseInt(height);
      var windowHeight = parseInt(window.innerHeight);

      // check vertical overflow
      if (positionTop >= 0 && positionTop - verticalOverflow < windowHeight - contentHeight) {
        this.content.style.top = "".concat(parseInt(top) + movementY, "px");
        sessionStorage.setItem('dialogPositionTop', this.content.style.top);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var prefixCls = props.prefixCls,
        maskClosable = props.maskClosable;
      var style = this.getWrapStyle();
      // clear hide display
      // and only set display after async anim, not here for hide
      if (props.visible) {
        style.display = null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-root")
      }, !props.onlyActiveTab && this.getMaskElement(), /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
        tabIndex: -1,
        onKeyDown: this.onKeyDown,
        className: "".concat(prefixCls, "-wrap ").concat(props.wrapClassName || ''),
        ref: this.saveRef('wrap'),
        onClick: maskClosable ? this.onMaskClick : null,
        onMouseUp: maskClosable ? this.onMaskMouseUp : null,
        role: "dialog",
        "aria-labelledby": props.title ? this.titleId : null,
        style: style
      }, props.wrapProps), this.getDialogElement()));
    }
  }]);
}(React.Component);
(0, _defineProperty2.default)(Dialog, "defaultProps", {
  className: '',
  mask: true,
  visible: false,
  keyboard: true,
  closable: true,
  maskClosable: true,
  destroyOnClose: false,
  prefixCls: 'rc-dialog',
  focusTriggerAfterClose: true,
  allowOverflow: false
});